<script setup lang="tsx">
import type { Column } from '@/stores/column'

const model = defineModel<Column>({ required: true })
</script>

<template>
	<span class="text-nowrap" @mousedown.prevent.stop="model.toggleOrder()">
		<i
			class="me-1 text-secondary bi"
			:class="{
				'bi-caret-up-fill': model.order === 'asc',
				'bi-caret-down-fill': model.order === 'desc',
				'bi-list-ol': !model.order,
			}"
		></i>
		<slot></slot>
	</span>
</template>

<style lang="sass" scoped>
span:hover
    cursor: pointer
i
    font-size: .85rem
</style>
